import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FeedsService } from '../../services/feeds/feeds.service';
import { SessionMgmtService } from '../../services/session-mgmt/session-mgmt.service';
import { ManagerConfigurationsService } from '../../services/manager-configurations/manager-configurations.service';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../../services/utils/utils.service';
import { ReCaptchaV3Service } from 'ng-recaptcha-2';
import { ToastService } from '../../services/toast/toast.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CdkDragDrop, CdkDropList, CdkDrag, moveItemInArray, CdkDragPlaceholder } from '@angular/cdk/drag-drop';
import * as _ from 'lodash';
import * as moment from 'moment';
import { NgIf, NgFor } from '@angular/common';
import { LtmsLoaderComponent } from '../ltms-loader/ltms-loader.component';
import { LtmsDataTableV2Component } from '../ltms-data-table-v2/ltms-data-table-v2.component';
import { FormsModule } from '@angular/forms';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { LtmsErrorComponent } from '../ltms-error/ltms-error.component';
import { GlobalFilterService } from '../../services/filters/global-filter.service';
@Component({
  selector: 'litmus-response-downloader',
  templateUrl: './litmus-response-downloader.component.html',
  styleUrl: './litmus-response-downloader.component.scss',
  imports: [NgIf, LtmsLoaderComponent, LtmsDataTableV2Component, FormsModule, CdkDropList, CdkScrollable, NgFor, CdkDrag, CdkDragPlaceholder, LtmsErrorComponent]
})
export class LitmusResponseDownloaderComponent implements OnInit {
  @Input() brandDetails: any = {}
  @Input() paginationDetail: any = {};
  @Input() filters: any = {};
  @Output() onClose: any = new EventEmitter<any>();
  destroyRef = inject(DestroyRef);
  columns: any = [{
    header: 'Filename',
    dataKey: 'truncatedFileName',
    dataType: "string",
    enabled: true,
    // clickable: true, 
    isHtmlExist: true,
    style: {
      headerTextAlign: 'left',
      cellTextAlign: 'left',
      width: "10%"
    },
    order: 1
  },
  {
    header: 'Requested on',
    dataKey: 'requestedOn',
    sortBy: 'requested_on',
    dataType: "string",
    enabled: true,
    style: {
      headerTextAlign: 'left',
      cellTextAlign: 'left',
      width: "10%"
    },
    order: 1
  },
  {
    header: 'Sent on',
    dataKey: 'receivedOn',
    sortBy: 'received_on',
    dataType: "string",
    enabled: true,
    style: {
      headerTextAlign: 'left',
      cellTextAlign: 'left',
      width: "10%"
    },
    order: 1
  },
  {
    header: 'Status',
    dataKey: 'status',
    dataType: "string",
    enabled: true,
    style: {
      headerTextAlign: 'left',
      cellTextAlign: 'left',
      width: "10%"
    },
    order: 1
  },
  {
    header: 'Count',
    dataKey: 'count',
    dataType: "string",
    enabled: true,
    style: {
      headerTextAlign: 'center',
      cellTextAlign: 'center',
      width: "10%"
    },
    order: 1
  }
    , {
    header: 'Download Date Range',
    dataKey: 'dateRange',
    dataType: "string",
    enabled: true,
    style: {
      headerTextAlign: 'left',
      cellTextAlign: 'left',
      width: "10%"
    },
    order: 1
  },
  {
    header: 'Remarks',
    dataKey: 'remarks',
    dataType: "string",
    enabled: true,
    style: {
      headerTextAlign: 'left',
      cellTextAlign: 'left',
      width: "10%"
    },
    order: 1
  }

  ]
  rows: any = []

  reCAPTCHAToken: any = null;
  excludedFields: any = [];
  includedFields: any = [];
  fieldDefinitions: any = [];
  loginResponse: any = {};

  loggedManagerId: string = ''
  adrdata: any = []
  loadingTableData: boolean = false;
  isAllFieldSelected: boolean = true
  activeTab: string = 'new_request'
  searchText: string = '';
  fieldDefinitionsStore: any = [];
  isFieldListLoaded: boolean = false;
  isFieldsAvaible: boolean = false;
  sendingReport: boolean = false
  isResetInProgress: boolean = false;
  isSavingInProgress: boolean = false;
  constructor(
    private managerConfigurations: ManagerConfigurationsService,
    private feedsService: FeedsService,
    private _toast: ToastService,
    private _session: SessionMgmtService,
    private _utilsService: UtilsService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private _filterService: GlobalFilterService
  ) { }

  ngOnInit(): void {
    this.activeTab = 'new_request'
    this.executeRecaptcha();
    this.prepareData();
  }

  // Executes reCAPTCHA v3 and stores the token; handles async errors in subscribe and sync errors via try-catch.
  executeRecaptcha() {
    try {
      this.recaptchaV3Service.execute('importantAction').pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe({
        next: (token: string) => {
          this.reCAPTCHAToken = token;
        },
        error: (error) => {
          console.error('Error executing reCAPTCHA:', error);
          this._toast?.showPopup?.('ERROR', 'Error', 'Failed to verify reCAPTCHA. Please try again.', 10000);
        }
      });
    } catch (err) {
      // This will only catch synchronous errors, not observable stream errors
      console.error('reCAPTCHA service not available:', err);
      this._toast?.showPopup?.('ERROR', 'Error', 'Security verification is unavailable. Please try again later or check browser settings.', 10000);
    }
  }

  prepareData() {
    this.isFieldListLoaded = false
    this.includedFields = [];
    this.loginResponse = _.get(Helpers, 'managerDetails', {});
    this.loggedManagerId = _.get(this.loginResponse, 'manager._id');
    // this.fieldDefinitions = Helpers.deepClone(this.brandDetails.field_definitions)
    this.getFieldDefinitionForUser().then((fieldDefinitions: any) => {
      // this.fieldDefinitions = fieldDefinitions;
      this.includedFields = _.filter(Helpers.deepClone(fieldDefinitions), (field: any) => field.download)
      this.fieldDefinitions = Helpers.deepClone(fieldDefinitions)
      this.fieldDefinitionsStore = Helpers.deepClone(fieldDefinitions)
      this.isAllFieldSelected = (this.fieldDefinitions.length == this.includedFields.length) ? true : false;
      this.isFieldListLoaded = true;
      this.isFieldsAvaible = (fieldDefinitions.length) ? true : false;
    })

    if (this.activeTab == 'my_download') {
      this.displayADRProgress();
    }
  }

  changeTab(tabname: string) {
    this.activeTab = tabname
    if (tabname == 'my_download') {
      this.displayADRProgress()
    }
  }

  closeModal() {
    this.onClose.emit()
  }

  updateIncludeFields(event: any, data: any) {
    event.preventDefault()
    const flag = !data.download
    this.fieldDefinitions = _.map(this.fieldDefinitions, (field: any) => {
      if (data.field_id == field.field_id) {
        field.download = flag;
      }
      return field;
    })
    this.fieldDefinitionsStore = _.map(this.fieldDefinitionsStore, (field: any) => {
      if (data.field_id == field.field_id) {
        field.download = flag;
      }
      return field;
    })

    this.includedFields = _.filter(Helpers.deepClone(this.fieldDefinitionsStore), (field: any) => field.download)
    this.updateAllSelectedFlag();
  }

  toggaleDownloadFields(event: any) {
    event.preventDefault();
    this.fieldDefinitions = _.map(this.fieldDefinitions, (field: any) => {
      field.download = (this.isAllFieldSelected) ? false : true;
      return field;
    })
    if (this.isAllFieldSelected) {
      this.isAllFieldSelected = false;
    } else {
      this.isAllFieldSelected = true
    }

    this.fieldDefinitionsStore = _.map(this.fieldDefinitionsStore, (item: any) => {
      const field = _.find(this.fieldDefinitions, { field_id: item.field_id });
      if (field) {
        item.download = field.download;
      }
      return item;
    })
    this.includedFields = _.filter(Helpers.deepClone(this.fieldDefinitionsStore), (field: any) => field.download)
    // this.includedFields = (this.isAllFieldSelected) ? [] : Helpers.deepClone(this.fieldDefinitions)
    // this.isAllFieldSelected = (this.fieldDefinitions.length == this.includedFields.length) ? true : false;
  }

  getFieldDefinitionForUser() {
    return new Promise((resolve) => {
      // Get the field_definitions from brand
      let fieldDefinitions = Helpers.deepClone(this.brandDetails.field_definitions);
      // Filter fields where the download is enabled
      fieldDefinitions = _.filter(fieldDefinitions, function (field: any) {
        return field.download;
      });
      var query = this.getInitialQueryParameters();;
      this.managerConfigurations.getManagerConfigurationsByQuery(query).pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe((response) => {
        if (response.code == 0 && _.hasIn(response, 'data.manager_config') && !_.isEmpty(response, 'data.manager_config')) {
          var managerConfig = response.data.manager_config[0];
          // If the manager config is available then get the field_definitions
          var managerFieldDef = _.get(managerConfig, 'advanced_downloader.field_definitions');
          if (managerFieldDef) {
            fieldDefinitions = _.map(fieldDefinitions, (item: any) => {
              const index = _.findIndex(managerFieldDef, { field_id: item.field_id });
              if (index >= 0) {
                item.download = true
                item.sequence = index
              } else {
                item.download = false;
              }
              return item;
            })
            fieldDefinitions = _.orderBy(fieldDefinitions, ['sequence'], ['asc']);
            fieldDefinitions = _.map(fieldDefinitions, (item: any, index: any) => {
              item.sequence = index;
              return item;
            });
            resolve(fieldDefinitions);
          } else {
            resolve(fieldDefinitions);
          }
        } else {
          resolve(fieldDefinitions);
        }
      })
    })
  }

  updateReportDownloadSettings(event: any, reset?: boolean) {
    event.preventDefault();
    this.searchText = '';
    if (reset) {
      this.isResetInProgress = true
    } else {
      this.isSavingInProgress = true
    }
    var presentFields = this.getFieldsSequence();
    // Prepare the query for update
    var params: any = this.getInitialQueryParameters();;
    var query: any = {};
    if (params.brand_id) {
      query.brand_id = params.brand_id;
    }
    if (params.group_id) {
      query.group_id = params.group_id;
    }
    if (params.shop_id) {
      query.shop_id = params.shop_id;
    }
    var configObj: any = {
      'advanced_downloader': {
        'field_definitions': presentFields
      }
    }
    if (reset == true) {
      configObj = {
        'advanced_downloader': {}
      }
    }
    // Updating manager based field_definitions.
    this.managerConfigurations.updateManagerConfigurations(query, configObj).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((response) => {
      if (response.code == 0) {
        this.prepareData();
        Helpers.smallAlertBox("Success", "Your settings has been updated successfully", 'success', 4000)
      } else {
        Helpers.smallAlertBox('Error', 'something went wrong!!', 'error', 4000)
      }
      this.isResetInProgress = false;
      this.isSavingInProgress = false
    })
  }

  emailReport() {
    this.searchText = ''
    this.sendingReport = true;
    // If pagination details are available then check max download limit
    if (this.brandDetails && this.paginationDetail) {
      var maxNumberOfRecords = _.get(this.brandDetails, 'advanced_downloader_settings.max_number_of_records');
      var numberOfRecords = this.paginationDetail.total;
      if (maxNumberOfRecords && maxNumberOfRecords < numberOfRecords) {
        this.sendingReport = false;
        var message = "File requested for download cannot be generated as it exceeds the response count limit set (" + maxNumberOfRecords + " responses).";
        Helpers.smallAlertBox("Warning", message, 'warn');
        return;
      }
    }
    this.feedsService.mailAdvancedDownloadReport(this.getQueryDataForDownload()).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((response) => {
      if (response && response.data.code != 0) {
        this.sendingReport = false;
        Helpers.smallAlertBox("Info", (response.data.error_message).toString(), "Info");
      } else {
        Helpers.smallAlertBox("Success", "Your request has been submitted. You will receive an email with the link to the report.", "Success");
      }
      this.sendingReport = false;
    });
  }

  getQueryDataForDownload() {
    let tagIdList: any = []
    var downloadQuery: any = {
      from: Helpers.datePicker.startDate,
      to: Helpers.datePicker.endDate,
      date_filter_type: parseInt(this.filters["dateFilterType"])
    }

    if (this.filters) {
      if (this.filters.shopIds && this.filters.shopIds.length) {
        downloadQuery.shop_id_list = this.filters.shopIds;
      } else if (this.filters.shopId && this.filters.shopId) {
        downloadQuery.shop_id_list = [this.filters.shopId]
      } else if (this.filters.groupId && this.filters.groupId) {
        downloadQuery.group_id = this.filters.groupId;
      } else if (this.filters.brandId && this.filters.brandId) {
        downloadQuery.brand_id = this.filters.brandId
      }
    }

    downloadQuery['filters'] = {}

    downloadQuery["fields"] = this.getFieldsListForDownload();

    if (('brand_id' in downloadQuery) == false) {
      downloadQuery['brand_id'] = this.brandDetails._id;
    }

    downloadQuery['filters']['primary_rating_range'] = this.filters["primaryRatingLevels"];
    var is_dynamic_project = this.brandDetails && this.brandDetails.is_single_touchpoint_setup;

    if (is_dynamic_project && Helpers.hierarchyStack && Helpers.hierarchyStack.length > 0) {

      let customFilterList: any = [];
      //Since Helpers.customFilterList is deprecated
      _.each(Helpers.hierarchyStack, function (hierarchy) {
        customFilterList.push({ 'field_id': hierarchy['field_id'], 'value': hierarchy['group_key'][0] })
      });

      downloadQuery['custom_filter_list'] = customFilterList;
    }

    if (_.get(this, "filters.statusIds.length") > 0) {
      downloadQuery['filters']['status_id_list'] = this.filters["statusIds"];
    }

    // if (categoryIds && categoryIds.length > 0) {
    if (_.get(this, "filters.categoryIds.length") > 0) {
      downloadQuery['filters']['category_id_list'] = this.filters["categoryIds"]
    }

    // if (tagIdList && tagIdList.length > 0) {
    if (_.get(this, "filters.tagIds.length") > 0) {
      downloadQuery['filters']['tag_id_list'] = tagIdList;
    }


    if (this.filters["assignedToIds"] && this.filters["assignedToIds"].length) {
      downloadQuery['filters']['assigned_to_id_list'] = this.filters["assignedToIds"];
    }

    if (this.filters["emptyCommentsFilter"] && this.filters["emptyCommentsFilter"] == 2) {
      downloadQuery['filters']['exclude_empty_comments'] = true;
    }

    if (this.filters["interactionStatus"]) {
      downloadQuery['filters']['interaction_status'] = this.filters["interactionStatus"];
    }
    if (this.filters["fieldId"]) {
      downloadQuery['filters']['field_id'] = this.filters["fieldId"];
    }

    //Added by Raj to enable universal filters in the Advanced Download request
    // Create a deep copy to avoid mutating the global object
    downloadQuery['filters']['universal_filter'] = (!_.isEmpty(Helpers.universalFilter)) ? Helpers.deepClone(Helpers.universalFilter) : {};

    // Check if comment filter exists in filters and append to universal_filter if not already present
    if (this.filters && this.filters["universalFilter"] && this.filters["universalFilter"]["action_filter"] && this.filters["universalFilter"]["action_filter"]["comment"]) {
      // Check if universal_filter already has action_filter with comment
      if (!downloadQuery['filters']['universal_filter']['action_filter'] || !downloadQuery['filters']['universal_filter']['action_filter']['comment']) {
        // Initialize action_filter if it doesn't exist
        if (!downloadQuery['filters']['universal_filter']['action_filter']) {
          downloadQuery['filters']['universal_filter']['action_filter'] = {};
        }
        // Append the comment filter - create a copy to avoid mutation
        downloadQuery['filters']['universal_filter']['action_filter']['comment'] = Helpers.deepClone(this.filters["universalFilter"]["action_filter"]["comment"]);
      }
    }

    // Added by shailesh - added flag to control is_excluded from analytics feeds
    if (this.filters["includeExcludedFeeds"]) {
      downloadQuery['filters']['is_excluded_from_analytics'] = this.filters["includeExcludedFeeds"];
    }

    if (this.filters["isVerbatim"]) {
      downloadQuery['is_verbatim'] = this.filters["isVerbatim"];
      downloadQuery['verbatim_limit'] = this.filters["verbatim_limit"] ? this.filters["verbatim_limit"] : 10; // If 'verbatim_limit' is not set in DB, default to 10
    }

    //Added by Raj to enable manager_access_filter in the Advanced Download request
    var is_valid = Helpers.brandDetails && Helpers.brandDetails.is_single_touchpoint_setup && Helpers.hierarchyStack && Helpers.hierarchyStack.length;
    if (is_valid) {
      var access_obj = {},
        shortener = Helpers.hierarchyStack[0];

      access_obj[shortener['field_id']] = shortener['group_key'];
      downloadQuery['filters']['manager_access_filter'] = access_obj;
    } else
      downloadQuery['filters']['manager_access_filter'] = {};

    downloadQuery['manager_id'] = this.loggedManagerId;

    return downloadQuery;
  }


  getFieldsSequence() {
    var presentFields: any = [];
    var activePresetField = [];
    this.fieldDefinitions = _.orderBy(Helpers.deepClone(this.fieldDefinitionsStore), ['sequence'], ['asc'])
    _.each(this.fieldDefinitions, (field: any) => {
      if (field.download) {
        presentFields.push({
          'field_id': field.field_id,
          'download': true
        });
      }
    })
    // _.each(this.includedFields, (value) => {
    //   for (var i = 0; i < this.fieldDefinitions.length; i++) {
    //     if (this.fieldDefinitions[i].field_id == value.field_id && this.fieldDefinitions[i].name == value.name && this.fieldDefinitions[i].download) {
    //       presentFields.push({
    //         'field_id': this.fieldDefinitions[i].field_id,
    //         'download': true
    //       });
    //     }
    //   }
    // });
    return presentFields;
  }

  getFieldsListForDownload() {
    let selectedFields: any = [];
    _.each(this.includedFields, (value: any) => {
      _.each(this.brandDetails.field_definitions, (fieldObj: any) => {
        if (fieldObj.field_id == value.field_id) {
          selectedFields.push(fieldObj);
        }
      })

    })
    return selectedFields;
  }

  getInitialQueryParameters() {

    var parameter = Helpers.deepClone(Helpers.accessObject);
    var initialQueryParams: any = {};

    if (!_.isEmpty(parameter)) {
      initialQueryParams = {
        "manager_type": parameter.manager_type,
        "brand_id": parameter.brand_id
      }
      if (parameter.manager_type == 1 && parameter.shop_id) {
        initialQueryParams.shop_id = Helpers.touchpointId;
        initialQueryParams.main_rater_type = this.brandDetails.main_rater_type;
      } else if (parameter.manager_type == 7 && parameter.group_id) {
        initialQueryParams.group_id = parameter.group_id;
        initialQueryParams.main_rater_type = this.brandDetails.main_rater_type;
      } else if (parameter.manager_type == 2 && parameter.brand_id) {
        initialQueryParams.brand_id = parameter.brand_id;
        initialQueryParams.main_rater_type = this.brandDetails.main_rater_type;
      }

      if (Helpers.touchpointId) {
        initialQueryParams.shop_id = Helpers.touchpointId;
      } else if (Helpers.groupId) {
        initialQueryParams.group_id = Helpers.groupId;
      }

      if (!Helpers.touchpointId) {
        initialQueryParams.shop_id_list = Helpers.shopIdList;
      }

      if (Helpers.hierarchyStack && Helpers.hierarchyStack.length) {
        initialQueryParams.hierarchy_stack = Helpers.hierarchyStack;
      }

      if (Helpers.customFilterNextLevel && _.get(this.brandDetails, "is_single_touchpoint_setup")) {
        initialQueryParams.group_alias_key = Helpers.customFilterNextLevel;
      }

      if (Helpers.customFilterList && Helpers.customFilterList.length) {
        initialQueryParams.hierarchy_stack = [];
        Helpers.customFilterList.forEach(function (filter) {
          initialQueryParams.hierarchy_stack.push({
            "field_id": filter.field,
            "group_key": [filter.value]
          })
        });
      }
    }

    return initialQueryParams;
  }


  displayADRProgress() {
    this.loadingTableData = true;
    this.adrdata = [];
    var obj = {
      brand_id: this.brandDetails._id,
      manager_id: this.loggedManagerId,
    };

    this.feedsService.getADRProgresStatus(obj).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((response) => {
      if (response.data && response.data.adr_status && response.data.adr_status.length > 0) {
        var adrStatusArray = response.data.adr_status;
        this.adrdata = _.map(adrStatusArray, (item: any) => {
          return this.processADRStatus(item);
        })

      }
      this.loadingTableData = false;
    }, (error) => {
      console.error("Error fetching data:", error);
      this.loadingTableData = false;
    });
  }

 processADRStatus(item: any) {
  const url = this._utilsService.apiUrlGeneration(
    environment.webPrivateV1,
    environment.webPrivateV1.infraFileDownload
  );
  let downloadUrl =
    _.get(item, "status") === "Processed" && item.row_count !== 0
      ? url + item._id
      : null;

  let truncatedFileName = "";
  try {
    if (item.bucket_url) {
      truncatedFileName = item.bucket_url.split("/")[3].split("_-")[0];
    }
  } catch (error) {
    console.error(
      "Error occurred while extracting truncatedFileName from bucket_url:",
      error
    );
    const accountId = Helpers.brandDetail.account_id;
    const accountName = Helpers.accountDetails[accountId].name;
    truncatedFileName = accountName + "_" + Helpers.brandDetail.name;
  }

  const truncatedFileName15 = truncatedFileName.substring(0, 15);
  const displayedFileName =
    _.get(item, "status") === "Processed" ? truncatedFileName15 : "NA";

  // Format date range
  const formattedFrom = new Date(
    item.parameters.from.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3")
  )
    .toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    })
    .replace(/,/g, "");
  const formattedTo = new Date(
    item.parameters.to.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3")
  )
    .toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    })
    .replace(/,/g, "");
  const formattedDateRange = `${formattedFrom.split(" ")[1]} ${
    formattedFrom.split(" ")[0]
  } ${formattedFrom.split(" ")[2]} - ${formattedTo.split(" ")[1]} ${
    formattedTo.split(" ")[0]
  } ${formattedTo.split(" ")[2]}`;

  const countValue =
    item.row_count !== undefined && item.row_count !== null
      ? item.row_count
      : "NA";
  const receivedOn = item.end_date ? item.end_date : "NA";

  // Handle remarks
  let remarksText = "NA";
  if (item.error_reason && item.error_reason.trim() !== "") {
    remarksText = item.error_reason;
  } else if (item.status === "Processed") {
    remarksText = "Success";
  } else if (item.status === "Processing" || item.status === "Unprocessed") {
    remarksText = "Wait";
  }

  const tableData: any = {
    fileName: downloadUrl,
    truncatedFileName: "",
    requestedOn: moment(_.get(item, "created_date")).format(
      "DD MMM YYYY [at] HH:mm"
    ),
    requested_on: _.get(item, "created_date"),
    receivedOn:
      receivedOn && receivedOn !== "NA"
        ? moment(receivedOn).format("DD MMM YYYY [at] HH:mm")
        : receivedOn,
    received_on: receivedOn,
    status: _.get(item, "status"),
    count: countValue,
    dateRange: formattedDateRange,
    remarks:
      remarksText.length > 20 ? remarksText.slice(0, 20) + "..." : remarksText,
    tooltip_text: {
      remarks: remarksText,
      truncatedFileName: "Click to download",
    },
  };

  // ✅ FINAL DISPLAY LOGIC
  if (item.error_reason && item.error_reason.trim() !== "") {
    if (item.error_reason === "Error sending mail") {
      // show actual clickable file name
      tableData.truncatedFileName = `<a href="${downloadUrl}" target="_blank">${displayedFileName}</a>`;
    } else {
      // any other error → show NA and keep remarks text as error
      tableData.truncatedFileName = "NA";
      tableData.tooltip_text.truncatedFileName = "NA";
    }
  } else if (_.get(item, "status") === "Processed" && item.bucket_url) {
    // successful processed download
    tableData.truncatedFileName = `<a href="${downloadUrl}" target="_blank">${displayedFileName}</a>`;
  } else {
    tableData.truncatedFileName = displayedFileName;
  }

  if (tableData.truncatedFileName === "NA") {
    tableData.tooltip_text.truncatedFileName = "NA";
  }

  return tableData;
}


  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.fieldDefinitions, event.previousIndex, event.currentIndex);
    this.fieldDefinitions = _.map(this.fieldDefinitions, (item: any, index: any) => {
      item.sequence = index;
      return item;
    });
    this.fieldDefinitions = _.orderBy(this.fieldDefinitions, ['sequence'], ['asc']);
    this.fieldDefinitionsStore = Helpers.deepClone(this.fieldDefinitions);
  }

  filterFields(event?: any) {
    event?.preventDefault();

    let searchText = this.searchText.trim();
    if (searchText != '') {
      searchText = searchText.toLowerCase()
      this.fieldDefinitions = _.filter(Helpers.deepClone(this.fieldDefinitionsStore), (field: any) => {
        return (field && field.name && field.name.toLowerCase().indexOf(searchText) >= 0)
      })

    } else {
      this.fieldDefinitions = Helpers.deepClone(this.fieldDefinitionsStore)
    }
    this.updateAllSelectedFlag();
  }

  updateAllSelectedFlag() {
    let count = 0;
    let isAllFieldSelected: boolean = false;
    _.each(this.fieldDefinitions, (item: any) => {
      if (item.download) {
        count = count + 1;
      }
    })
    if (count == this.fieldDefinitions.length) {
      isAllFieldSelected = true;
    }
    this.isAllFieldSelected = isAllFieldSelected
  }

  clearSearch() {
    this.searchText = '';
    this.filterFields()
    this.updateAllSelectedFlag();
  }

  downloadFile(event: any) {
    if (event && _.has(event, 'row.fileName')) {
      window.open(_.get(event, 'row.fileName'), '_blank');
    }
  }
}
